import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Group, Text, Box, Divider, Badge, Mark, TextInput } from '@mantine/core';
import { IconTrash, IconPlus } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { regexNumberOnly, safeValue, getObjectParam2, numberWithComma, stringDivider } from "../../utils/globalFunctions";

import ModalWrapperWithFooterCloseButton from "../../components/general/ModalWrapperWithFooterCloseButton";
import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import PaperWrapper from "../../components/utilities/PaperWrapper";
import InputComponent from "../../components/general/InputComponent";

import ComponentStockSelector from "../../pagesSub/trxProjectPengerjaan/ComponentStockSelector";

const StepSelesaiTambahanStock = ({ stateData, fnOnChange }) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorUbahHarga: 'stepSelesaiTambahanStock-2',
    errorBatalkanItem: 'stepSelesaiTambahanStock-3',
  })

  const refDefaultGaransiType = React.useRef(utils.batalPemakaianItem.salah_pilih.slug);

  const [data, setData] = React.useState({
    stockSelectorModal: false,
    stockSelectorTriggerUpdate: new Date(),

    hargaStock: {
      modalShow: false,
      modalHarga: '',
      modalHargaError: '',
      modalHargaPlaceHolder: '',
      stockName: '',
      tambahanStockId: '',
      submitLoading: false
    },

    batalPemakaianModal: false,
    batalPemakaianItemData: {
      stockId: '',
      tambahanStockId: '',
      name: '',
      itemStatus: '',
      masaGaransiType: '',
      masaGaransiBulan: '',
      masaGaransiHari: '',
      masaGaransiCanBeClaimed: '',
      tanggalPembelian: '',
      clientId: '',
      clientName: '',
      projectId: ''
    },

    batalPemakaianType: refDefaultGaransiType.current,
    batalPemakaianJumlah: '',
    batalPemakaianError: '',
    batalPemakaianLoadingSubmit: false,

    taggedInfo: {
      modal: false,
      customerName: '',
      projectId: ''
    },

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const submitDataHargaStockTambahan = () => {
    setData(d => ({ ...d, hargaStock: { ...d.hargaStock, modalHargaError: '' } }));

    if (validator.isEmpty(data.hargaStock.modalHarga, { ignore_whitespace: true })) {
      setData(d => ({ ...d, hargaStock: { ...d.hargaStock, modalHargaError: 'Isi harga stock terlebih dahulu.' } }));
    } else {
      setData(d => ({ ...d, hargaStock: { ...d.hargaStock, submitLoading: true } }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('harga', data.hargaStock.modalHarga);
      formDT.append('tambahan_stock_id', data.hargaStock.tambahanStockId);

      axios({
        method: 'post',
        url: BE_API_TWO + '/pembayaran_tambahan_stock_harga',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, hargaStock: { ...d.hargaStock, submitLoading: false, modalShow: false } }));

        if (response.data.flag_status === 'isset') {
          fnOnChange(response.data.data);

          setData(d => ({
            ...d,
            hargaStock: {
              ...d.hargaStock,
              modalHarga: ''
            }
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorUbahHarga,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, hargaStock: { ...d.hargaStock, submitLoading: false, modalShow: false } }));

        notifications.show({
          id: notificationId.current.errorUbahHarga,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  const batalkanPemakaianPart = () => {
    setData(d => ({ ...d, batalPemakaianError: '' }));

    if (parseInt(Number(data.batalPemakaianJumlah)) <= 0) {
      setData(d => ({ ...d, batalPemakaianError: 'Jumlah item wajib diisi.' }));
    } else {
      setData(d => ({
        ...d,
        batalPemakaianLoadingSubmit: true,
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('stock_id', data.batalPemakaianItemData.stockId);
      formDT.append('tambahan_stock_id', data.batalPemakaianItemData.tambahanStockId);
      formDT.append('jumlah_pemakaian_item', data.batalPemakaianJumlah);

      axios({
        method: 'post',
        url: BE_API_TWO + '/batalkan_pemakaian_item_tambahan',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, batalPemakaianLoadingSubmit: false, batalPemakaianModal: false }));

        if (response.data.flag_status === 'isset') {
          fnOnChange(response.data.data);

          setData(d => ({
            ...d,
            batalPemakaianJumlah: '',
            batalPemakaianError: '',
          }));
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorBatalkanItem,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'sepertinya-telah-terjadi-kesalahan') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Sepertinya telah terjadi kesalahan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'input-lebih-besar-dari-aktual') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: `Jumlah yang Anda masukkan lebih besar dari jumlah seharusnya !`,
              show: true
            }
          }))
        }
        //

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          batalPemakaianLoadingSubmit: false,
          batalPemakaianModal: false
        }))

        notifications.show({
          id: notificationId.current.errorBatalkanItem,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  return (
    <React.Fragment>
      <PaperWrapper stateMB="2rem">
        <Text>Tambahan Stock Item</Text>

        <Divider my='xs' />

        {Array.isArray(stateData.data) && (stateData.data.length > 0) && Object.keys(stateData.data).map((keyPS, indexPS) => {
          return (
            <Group
              key={keyPS}

              noWrap
              mt='lg'
              spacing='xs'
              sx={(tema) => ({
                alignItems: 'flex-start'
              })}
            >
              <Text size='sm'>{Number(indexPS) + 1}.</Text>

              <Box sx={{ width: '100%' }}>
                <Group spacing={6}>
                  <Text size='sm'>
                    {`${stateData.data[keyPS].stock_category_name} ${stateData.data[keyPS].stock_category_sub_name} ${safeValue(stateData.data[keyPS].stock_serial_number, '')}`}
                  </Text>

                  <Badge
                    size='md'
                    color={getObjectParam2(utils.stockItemStatus, stateData.data[keyPS].stock_status, 'color', 'gray')}

                    onClick={
                      // stateData.data[keyPS].stock_status === utils.stockItemStatus.tagged.value ?
                      () => {
                        setData(d => ({
                          ...d,
                          taggedInfo: {
                            ...d.taggedInfo,
                            customerName: stateData.data[keyPS].customer_name,
                            projectId: stateData.data[keyPS].tagged_project_id,
                            modal: true
                          }
                        }));
                      }
                      // :() => { }
                    }

                    sx={(tema) => ({
                      cursor: 'pointer',
                      // cursor: stateData.data[keyPS].stock_status === utils.stockItemStatus.tagged.value ? 'pointer' : 'default'
                    })}

                    styles={(tema) => ({
                      inner: {
                        fontWeight: 'normal',
                        textTransform: 'none',
                      }
                    })}
                  >
                    {getObjectParam2(utils.stockItemStatus, stateData.data[keyPS].stock_status, 'caption', ' - ')}
                  </Badge>
                </Group>

                <Box>
                  {
                    // stateData.data[keyPS].stock_status === utils.stockItemStatus.tagged.value && 
                    stateData.data[keyPS].customer_name &&
                    <Text size='xs' color={getObjectParam2(utils.stockItemStatus, stateData.data[keyPS].stock_status, 'color', 'gray')}>
                      Tagged {safeValue(stateData.data[keyPS].customer_name, ' - ')}
                    </Text>
                  }

                  {
                    // stateData.data[keyPS].stock_status === utils.stockItemStatus.tagged.value && 
                    stateData.data[keyPS].tagged_project_id &&
                    <Text size='xs' color={getObjectParam2(utils.stockItemStatus, stateData.data[keyPS].stock_status, 'color', 'gray')}>
                      Tagged {stringDivider(stateData.data[keyPS].tagged_project_id, [4, 6, 8], '.', ' - ')}
                    </Text>
                  }
                </Box>

                <Group noWrap spacing='xs' mt='xs'>
                  <TextInput
                    id={'harga-penggunaan-stock' + indexPS}
                    size="xs"
                    variant='default'
                    icon={
                      <Text color="dimmed" size='sm'>
                        {safeValue(stateData.data[keyPS].project_tambahan_stock_jumlah_penggunaan, '')} x Rp
                      </Text>
                    }
                    readOnly={true}
                    placeholder='Harga Satuan'
                    value={numberWithComma(safeValue(stateData.data[keyPS].project_tambahan_stock_harga_jual_actual, ''))}

                    onClick={() => {
                      setData(d => ({
                        ...d,
                        hargaStock: {
                          ...d.hargaStock,
                          modalHarga: stateData.data[keyPS].project_tambahan_stock_harga_jual_actual,
                          modalHargaError: '',

                          modalHargaPlaceHolder: stateData.data[keyPS].stock_harga_jual,

                          stockName: `${stateData.data[keyPS].stock_category_name} ${stateData.data[keyPS].stock_category_sub_name} ${safeValue(stateData.data[keyPS].stock_serial_number, '')}`,

                          tambahanStockId: stateData.data[keyPS].project_tambahan_stock_id,
                          modalShow: true
                        }
                      }))
                    }}

                    sx={{
                      width: `100% !important`
                    }}

                    styles={(tema) => ({
                      input: {
                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                        paddingLeft: '4.5rem !important'
                      },
                      icon: {
                        width: '4.5rem'
                      }
                    })}
                  />
                </Group>
              </Box>

              <ActionIconComponent
                stateVariant='light'
                stateRadius='xl'
                stateTitle='Remove'
                stateSize='sm'
                StateIcon={IconTrash}
                stateIconSize='1rem'
                stateIconStrokeWidth={1.25}

                fnOnClick={() => {
                  setData(d => ({
                    ...d,
                    batalPemakaianModal: true,
                    batalPemakaianType: refDefaultGaransiType.current,
                    batalPemakaianJumlah: '',

                    batalPemakaianItemData: {
                      ...d.batalPemakaianItemData,
                      name: `${stateData.data[keyPS].stock_category_name} ${stateData.data[keyPS].stock_category_sub_name} ${safeValue(stateData.data[keyPS].stock_serial_number, '')}`,
                      itemStatus: stateData.data[keyPS].stock_status,
                      masaGaransiType: stateData.data[keyPS].stock_masa_garansi_type,
                      masaGaransiBulan: stateData.data[keyPS].stock_masa_garansi_bulan,
                      masaGaransiHari: stateData.data[keyPS].stock_masa_garansi_hari,
                      masaGaransiCanBeClaimed: stateData.data[keyPS].can_be_claimed,
                      stockId: stateData.data[keyPS].stock_id,
                      tambahanStockId: stateData.data[keyPS].project_tambahan_stock_id,
                      tanggalPembelian: stateData.data[keyPS].stock_tanggal_beli,
                      clientName: stateData.clientName,
                      clientId: stateData.clientId,
                      projectId: stateData.projectId,
                    }
                  }))
                }}
              />
            </Group>
          )
        })}

        {Array.isArray(stateData.data) && (stateData.data.length <= 0) &&
          <Text size='sm' color="dimmed">Tidak ada stock item yang digunakan.</Text>
        }

        <ComponentStockSelector
          stateShow={data.stockSelectorModal}
          fnShow={() => setData(d => ({ ...d, stockSelectorModal: false }))}

          stateIsForTambahanStock={true}

          stateData={stateData}
          statePreventNotChange={data.stockSelectorTriggerUpdate}
          statePengerjaanProgresId=''
          fnResult={(val) => fnOnChange(val)}
        >
          <Group
            spacing={5}
            px='xs'
            py='0.25rem'
            mt='xl'
            position="center"

            sx={(tema) => ({
              borderWidth: '1px',
              borderStyle: 'dashed',
              borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
              borderRadius: tema.radius.sm,
              color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
              }
            })}

            onClick={() => setData(d => ({
              ...d,
              stockSelectorModal: true,
              stockSelectorTriggerUpdate: new Date()
            }))}
          >
            <IconPlus size='0.8rem' />
            <Text size='sm'>Tambahan Stock Item</Text>
          </Group>
        </ComponentStockSelector>
      </PaperWrapper>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.hargaStock.modalShow}
        fnHide={() => setData(d => ({
          ...d,
          hargaStock: {
            ...d.hargaStock,
            modalShow: false
          }
        }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Harga Stock Item').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.hargaStock.submitLoading}
        fnButtonAction={submitDataHargaStockTambahan}
      >
        <InputComponent
          stateId='hargaPenggunaanStockTambahanModal-1'
          stateWithAsterisk={false}
          stateLabel={<Text color="dimmed">{data.hargaStock.stockName}</Text>}
          stateDescription=''
          statePlaceHolder={data.hargaStock.modalHargaPlaceHolder ? numberWithComma(data.hargaStock.modalHargaPlaceHolder) : ''}
          stateReadOnly={false}
          stateValue={numberWithComma(data.hargaStock.modalHarga)}
          stateError={data.hargaStock.modalHargaError}
          stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

          fnOnChange={(e) => setData(d => ({
            ...d,
            hargaStock: {
              ...d.hargaStock,
              modalHarga: regexNumberOnly(e.target.value)
            }
          }))}
        />
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.batalPemakaianModal}
        fnHide={() => setData(d => ({ ...d, batalPemakaianModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Pengembalian Item').toUpperCase()}
        stateOverlayZIndex={201}
        stateScrollArea={true}

        stateButtonClosePx='md'
        // stateSize="lg"

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor=""
        stateButtonActionLoading={data.batalPemakaianLoadingSubmit}
        fnButtonAction={batalkanPemakaianPart}
      >
        <PaperWrapper stateMT="1rem">
          <Group spacing='xs'>
            <Text>{data.batalPemakaianItemData.name}</Text>
            <Badge
              size='md'
              color={getObjectParam2(utils.stockItemStatus, data.batalPemakaianItemData.itemStatus, 'color', 'gray')}

              styles={() => ({
                inner: {
                  fontWeight: 'normal',
                }
              })}
            >
              {getObjectParam2(utils.stockItemStatus, data.batalPemakaianItemData.itemStatus, 'caption', ' - ')}
            </Badge>
          </Group>
        </PaperWrapper>

        <Box
          mt='1rem'
          mb='1rem'
        >
          <InputComponent
            stateId='pembatalan-jumlah'
            stateWithAsterisk={false}
            stateLabel='Jumlah item yang akan dibatalkan'
            stateDescription=''
            statePlaceHolder='Jumlah'
            stateValue={data.batalPemakaianJumlah}
            stateError=''

            fnOnChange={(e) => setData(d => ({
              ...d,
              batalPemakaianJumlah: regexNumberOnly(e.target.value)
            }))}
          />
        </Box>

        {data.batalPemakaianError &&
          <Text size='sm' color="red" my='sm'>
            {data.batalPemakaianError}
          </Text>
        }
      </ModalTakeAction>

      <ModalWrapperWithFooterCloseButton
        stateShow={data.taggedInfo.modal}
        fnHide={() => setData(d => ({ ...d, taggedInfo: { ...d.taggedInfo, modal: false } }))}
        stateHideOnClickOutSide={true}
        stateTitle={String('Information').toUpperCase()}
        // stateSize='xl'
        stateOverlayZIndex={201}
        stateWithCloseButton={true}
        stateScrollArea={true}

        stateButtonCloseCaption="Close"
        stateButtonCloseSize="xs"
        stateButtonClosePx="lg"
      >
        {data.taggedInfo.customerName ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk customer <Mark>&nbsp;{safeValue(data.taggedInfo.customerName, ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada customer tag untuk item ini.
          </Text>
        }

        {data.taggedInfo.projectId ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk project <Mark>&nbsp;{stringDivider(data.taggedInfo.projectId, [4, 6, 8], '.', ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada project tag untuk item ini.
          </Text>
        }
      </ModalWrapperWithFooterCloseButton>
    </React.Fragment>
  )
}

export default StepSelesaiTambahanStock;